import React from 'react';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ResultsSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const studentResults = ['Comprenden las corrientes psicológicas con claridad', 'Analizan situaciones reales desde conceptos teóricos', 'Participan más en clase', 'Reflexionan sobre identidad y emociones', 'Conectan la Psicología con su vida cotidiana'];
  const teacherResults = ['Ahorrás horas de planificación', 'Enseñás con estructura y seguridad', 'Tenés todo organizado por unidad', 'Llegás sin estrés al cierre del año', 'Recuperás tiempo personal'];
  return <section className="bg-blue-50 py-6 md:py-8 px-4" data-id="element-182">
      <div className="max-w-6xl mx-auto" data-id="element-183">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-6" data-id="element-184">
          Resultados que Transforman
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-6" data-id="element-185">
          {/* Students Column */}
          <div className="bg-white p-6 rounded-2xl shadow-sm" data-id="element-186">
            <h3 className="text-2xl font-bold text-blue-600 mb-4 border-b pb-3" data-id="element-187">
              Para tus Estudiantes
            </h3>
            <ul className="space-y-3" data-id="element-188">
              {studentResults.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-189">
                  <div className="mt-1 bg-green-100 p-1 rounded-full flex-shrink-0" data-id="element-190">
                    <Check className="w-4 h-4 text-green-600" strokeWidth={3} data-id="element-191" />
                  </div>
                  <span className="text-gray-700 font-medium text-lg" data-id="element-192">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Teachers Column */}
          <div className="bg-white p-6 rounded-2xl shadow-sm" data-id="element-193">
            <h3 className="text-2xl font-bold text-purple-600 mb-4 border-b pb-3" data-id="element-194">
              Para Vos como Docente
            </h3>
            <ul className="space-y-3" data-id="element-195">
              {teacherResults.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-196">
                  <div className="mt-1 bg-green-100 p-1 rounded-full flex-shrink-0" data-id="element-197">
                    <Check className="w-4 h-4 text-green-600" strokeWidth={3} data-id="element-198" />
                  </div>
                  <span className="text-gray-700 font-medium text-lg" data-id="element-199">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="text-center" data-id="element-200">
          <CTAButton onClick={scrollToPricing} className="w-full md:w-auto px-10 py-4 text-xl" data-id="element-201">
            👉 QUIERO LOGRAR ESTO
          </CTAButton>
        </div>
      </div>
    </section>;
}